import { FC } from 'react'
import { Location } from '../../../../api/models'
import { Chip } from '@mui/material'
import { AgencyTypeValues } from '../../../../constants/AgencyType'
import { permitIsExpired } from '../../../../utils/permitUtils'

type PermitExpiredCellContentsProps = {
  agencyType: AgencyTypeValues
  location: Location
}

export const PermitExpiredCellContents: FC<PermitExpiredCellContentsProps> = ({ agencyType, location }) => {
  return permitIsExpired(location, agencyType) && <Chip label="Expired" data-testid="permit-expired-chip" color="error" />
}
